export const INCOME_PLATFORM_ENABLED_TAX_YEARS = [2024] // Rollee does not support multiple years, have to choose 1 year
export const INCOME_PLATFORM_STATUS_AVAILABLE = 'Available'
export const INCOME_PLATFORM_STATUS_CONNECTED = 'Connected'
export const INCOME_PLATFORM_DATA_STATUS_READY = 'Ready'
export const INCOME_PLATFORM_DATA_STATUS_IN_PROGRESS = 'InProgress'
